var map = {
	"./androidstudio.svg": 7148,
	"./aws.svg": 780,
	"./bootstrap.svg": 2001,
	"./c.svg": 9028,
	"./calculator.png": 5667,
	"./cc.png": 4113,
	"./chat.png": 9793,
	"./cpp.svg": 7124,
	"./css3.svg": 5953,
	"./dart.svg": 4754,
	"./developer.png": 8357,
	"./digitalocean.svg": 907,
	"./docker.svg": 3573,
	"./dvc.png": 7214,
	"./expressjs.svg": 2674,
	"./facultypicker.png": 9029,
	"./fastapi.svg": 1441,
	"./firebase.svg": 3634,
	"./flutter.svg": 8301,
	"./freelance.png": 2712,
	"./git.svg": 47,
	"./github.svg": 1948,
	"./graphql.svg": 8456,
	"./html5.svg": 6415,
	"./java.svg": 9997,
	"./javascript.svg": 4248,
	"./mongodb.svg": 2945,
	"./mysql.svg": 2421,
	"./nextjs.svg": 1991,
	"./nodejs.svg": 8068,
	"./nqueens.png": 1172,
	"./pathfinder.png": 8466,
	"./postgressql.svg": 9968,
	"./postman.svg": 6494,
	"./python.svg": 2355,
	"./reactjs.svg": 5707,
	"./redux.svg": 9761,
	"./sorting.png": 2943,
	"./spring.svg": 6210,
	"./sql.svg": 2211,
	"./thoughtscrest_logo.jpeg": 8501,
	"./ttt.png": 6991,
	"./vscode.svg": 135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4004;